import { render, staticRenderFns } from "./formTitle.vue?vue&type=template&id=2a8bd612&scoped=true&"
import script from "./formTitle.vue?vue&type=script&lang=js&"
export * from "./formTitle.vue?vue&type=script&lang=js&"
import style0 from "./formTitle.vue?vue&type=style&index=0&id=2a8bd612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8bd612",
  null
  
)

export default component.exports